import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalAddAndEdit from './component/ModalAddAndEdit';
import { getListPositions, position_rules_create, position_rules_delete, position_rules_list, position_rules_update, services_create, services_delete, services_list, services_update } from '../../services/apis';
import { HeaderTableCus, TYPE_MODAL } from '../../constants/constants';
import { useSelector } from 'react-redux';
import { formatNumber } from '../../utils/funcHelper';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

const ListCommissionServicePage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const [lstService, setLstService] = useState([]);
    const [lstPosition, setLstPosition] = useState([]);
    const userReducer = useSelector((state) => state.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'service_name',
            key: 'service_name',
            render: (text, record, index) => <a onClick={() => handleEditCommission(record)} style={{ paddingLeft: 12 }}>{text}</a>,
        },
        {
            title: 'Chức vụ',
            dataIndex: 'position_name',
            key: 'position_name',
            align: 'center',
            render: (text, record, index) => <a onClick={() => handleEditCommission(record)} style={{ paddingLeft: 12 }}>{text}</a>,
        },
        {
            title: 'Loại',
            dataIndex: 'commission_type',
            key: 'commission_type',
            align: 'center',
        },
        {
            title: 'Công tua',
            dataIndex: 'commission_value',
            key: 'commission_value',
            align: 'right',
            render: (text, record, index) => <div style={{ paddingRight: 12 }}><strong>{record?.commission_type === 'percent' ? `${text} %` : formatNumber(parseInt(text), 0)}</strong></div>,
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => handleEditCommission(record)} >Sửa</a>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeleteCommission(record)}
                        okText="Xóa"
                        cancelText="Hủy"
                        placement="topRight"
                    >
                        <a style={{ color: 'red' }}>Xóa</a>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleDeleteCommission = async (record) => {
        try {
            const params = {
                id: record?.id,
            }
            setLoading(true);
            const res = await position_rules_delete(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Xoá thành công');
                getDataCommissions(true);
            }
            else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const handleEditCommission = (record) => {
        setItemSelected(record);
        setTypeModal(TYPE_MODAL.EDIT);
        setShowModal(true);
        setTitleModal('Sửa cấu hình công tua');
    }
    const handleAddService = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm cấu hình công tua');
    }

    const getDataPositions = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListPositions(params);
            if (res && res.status === 1) {
                setLstPosition([...res?.data?.map(item => ({ ...item, label: item.name, value: item.id }))]);
            } else {
                message.error(res.msg);
                setLstPosition([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const getDataServices = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await services_list(params);
            if (res && res.status === 1) {
                setLstService([...res?.data?.map(item => ({ ...item, label: item.name, value: item.id }))]);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setLstService([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const getDataCommissions = async (showLoading) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
                page: 1,
                limit: 200,
            }
            if (showLoading) setLoading(true);
            const res = await position_rules_list(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        getDataCommissions(true);
    };
    const callApiAddCommission = async (data) => {
        try {
            const params = {
                ...data,
                created_by: userReducer?.user_info?.id
            }
            const res = await position_rules_create(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm mới thành công');
                getDataCommissions(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const callApiUpdateCommission = async (data) => {
        try {
            const params = {
                ...data,
                updated_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await position_rules_update(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Cập nhật thành công');
                getDataCommissions(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            callApiAddCommission(data);
        } else {
            callApiUpdateCommission(data);
        }
    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataPositions(), getDataCommissions(true), getDataServices()]).finally(() => setLoading(false));

    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Nhập tên'} />
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Space size="small">
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SearchOutlined />}
                            >
                                Tìm kiếm
                            </Button>
                            <Button danger
                                onClick={handleAddService}
                                icon={<PlusOutlined />}
                            >
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
                scroll={{ y: 600, x: 'max-content' }}
            />
            <ModalAddAndEdit
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
                listPosition={lstPosition}
                listService={lstService}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListCommissionServicePage);